<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel modal__panel--termination">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--leads"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form form--terminate">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">
              {{ isEditMode ? $t(`addLeadModal.${"editTitle"}`) : $t(`addLeadModal.${"title"}`) }}
            </div>
          </div>
        </div>
        <div class="add__form add__form--terminate">
          <transition name="fade" mode="out-in">
            <Loading v-if="formLoading" />
            <div v-else class="add__content">
              <div class="termination">
                <div class="termination__row">
                  <div class="termination__column">
                    <div class="form__field" v-if="customerDetails">
                      <div class="input input--default input--readonly">
                        <span v-if="customerDetails.member_type && customerDetails.member_type.id == 1">{{
                          customerDetails.company_name }}</span>
                        <span v-else>
                          {{ customerDetails.first_name }} {{ customerDetails.last_name }}</span>
                      </div>
                    </div>

                    <div class="form__field ">
                      <MultiSelectDropdown :items="categories" :reduce="(category) => category.id" label="name"
                        :placeholder="$t(`addLeadModal.${'categoryDropdown'}`)" :selected="categoryIds"
                        @input="categoryIds = $event" />
                    </div>

                    <div v-if="responseId === 'yes' && methodId === 'phone'">
                      <div class="form__field date-time-wrapper">
                        <div class="date-picker">
                          <Datepicker class="input input--default date-picker" :class="{ 'input--error': dateHasError }"
                            :config="statics.datePickerConfig" :placeholder="$t(`addCallModal.${'date'}`)
                              " v-model="date" />
                          <div class="form__error" v-if="dateHasError">
                            {{ $t(`addLeadModal.${'dateErrorMsg'}`) }}
                          </div>
                        </div>
                        <div class="date-picker">

                          <input type="time" class="input input--default input time-picker"
                            :class="{ 'input--error': timeHasError }" v-model="time" />
                          <div class="form__error" v-if="timeHasError">
                            {{ $t(`addLeadModal.${'timeErrorMsg'}`) }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form__field">
                      <VSelect :options="statuses" :reduce="(status) => status.id"
                        :placeholder="$t('addPrivateCostumerModal.status')" label="name" v-model="statusId"
                        class="select select--default" :class="{ 'select--error': statusHasError }" />
                      <div class="form__error" v-if="statusHasError">
                        {{ $t(`addPrivateCostumerModal.${"subStatusErrorMsg"}`) }}
                      </div>
                    </div>

                    <div class="form__field ">
                      <Datepicker class="input input--default" :class="{ 'select--error': deadlineHasError }"
                        :config="statics.datePickerConfig" :placeholder="$t(`addLeadModal.${'deadline'}`)"
                        v-model="deadline" />
                      <div class="form__error" v-if="deadlineHasError">
                        {{ $t(`addLeadModal.${'deadlineErrorMsg'}`) }}
                      </div>
                    </div>
                  </div>

                  <div class="termination__column termination__column--middle">
                    <div class="form__field">
                      <div v-if="agents && agents.length">
                        <VSelect class="select select--default" :options="agents"
                          :class="{ 'select--error': agentHasError }" :reduce="(agent) => agent.id"
                          :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                          :placeholder="$t(`addLeadModal.${'agentDropdown'}`)" v-model="agentId" />
                        <div class="form__error" v-if="agentHasError">
                          {{ $t(`addLeadModal.${"agentErrorMsg"}`) }}
                        </div>
                      </div>

                      <div v-else>
                        <div class="input input--default input--readonly">
                          {{ loggedUser.first_name }} {{ loggedUser.last_name }}
                        </div>
                      </div>
                    </div>

                    <div class="form__field dobule-form-fields">
                      <div :class="[(methodId && methodId !== 'termin') ? 'small-form-field' : 'big-form-field']">
                        <VSelect class="select select--default" :options="methods" :reduce="(method) => method.value"
                          :getOptionLabel="(method) => method.label"
                          :placeholder="$t(`addLeadModal.${'methodDropdown'}`)" v-model="methodId" />
                      </div>

                      <div v-if="methodId && methodId !== 'termin'" class="small-form-field">
                        <VSelect class="select select--default" :options="responses"
                          :reduce="(response) => response.value" :getOptionLabel="(response) => response.label"
                          :placeholder="$t(`addLeadModal.${'responseDropdown'}`)" v-model="responseId" />
                      </div>
                    </div>

                    <div v-if="responseId === 'yes' && methodId === 'phone'">
                      <div class="form__field form__field__call__duration">
                        <div class="call__duration__label">
                          <p><i>{{ $t(`addCallModal.${'callDuration'}`) }}</i></p>
                        </div>
                        <div style="display: flex; align-items: center; gap: 9px;">
                          <div class="call__duration__types">
                            <p class="call__duration__value"
                              :class="{ 'call__duration__value--active': durationMinutes == 15 }"
                              @click="selectCallDuration(15)">
                              15 min
                            </p>
                            <p class="call__duration__value"
                              :class="{ 'call__duration__value--active': durationMinutes == 30 }"
                              @click="selectCallDuration(30)">
                              30 min
                            </p>
                            <p class="call__duration__value"
                              :class="{ 'call__duration__value--active': durationMinutes == 45 }"
                              @click="selectCallDuration(45)">
                              45 min
                            </p>
                          </div>
                          <div style="width: 80px;">
                            <div class="custom-duration-wrapper" :class="{ 'input--error': durationHasError }">
                              <input type="number" v-model="hours" min="0" max="59" @input="validateHours"
                                class=" custom-duration" placeholder="HH" />
                              <p><b>:</b></p>
                              <input type="number" v-model="minutes" min="0" max="59" @input="validateMinutes"
                                class=" custom-duration" placeholder="mm" />
                            </div>
                          </div>
                        </div>
                        <div class="form__error" v-if="durationHasError">
                          {{ $t(`addLeadModal.${'durationErrorMsg'}`) }}
                        </div>
                      </div>
                    </div>

                    <div class="form__field ">
                      <VSelect class="select select--default" :options="referals"
                        :class="{ 'select--error': referalHasError }" :reduce="(referal) => referal.id"
                        :getOptionLabel="(referal) => referal.name"
                        :placeholder="$t(`addLeadModal.${'referalDropdown'}`)" v-model="referalId" />
                      <div class="form__error" v-if="referalHasError">
                        {{ $t(`addLeadModal.${"referalErrorMsg"}`) }}
                      </div>
                    </div>

                    <div class="form__field ">
                      <input type="text" :placeholder="$t(`addLeadModal.${'referalNote'}`)"
                        class="input input--default " v-model="referalNote">
                    </div>
                  </div>

                  <div class="termination__column">
                    <DropFile @input="files = $event" />
                  </div>
                </div>
                <div class="termination__row termination__textarea__row">
                  <div class="form__field form__notes__textarea">
                    <textarea :placeholder="$t(`addLeadModal.${'text'}`)" cols="30" rows="10"
                      class="input input--default termination__textarea" v-model="comment"
                      style="max-width: initial !important;">
                    </textarea>
                  </div>
                </div>


                <div class="url-links" v-if="deadline">
                  <h3 class="url-links__title">{{ $t(`calendar.${"title"}`) }}</h3>
                  <p class="url-links__subtitle">{{ $t(`calendar.${"subtitle"}`) }}</p>

                  <div class="calendar-link" v-if="deadline">
                    <div class="calendar-link__icon calendar-link__icon--google"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Google Calendar</div>
                    </div>
                    <button class="calendar-link__btn" @click="copyToClipboard(generateCalendarLinks().google)">

                      Copy
                    </button>
                  </div>

                  <div class="calendar-link" v-if="deadline">
                    <div class="calendar-link__icon calendar-link__icon--outlook"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Outlook</div>
                    </div>
                    <button class="calendar-link__btn" @click="copyToClipboard(generateCalendarLinks().outlook)">

                      Copy
                    </button>
                  </div>

                  <div class="calendar-link" v-if="deadline">
                    <div class="calendar-link__icon calendar-link__icon--office365"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Office 365</div>
                    </div>
                    <button class="calendar-link__btn" @click="copyToClipboard(generateCalendarLinks().office365)">

                      Copy
                    </button>
                  </div>

                  <div class="calendar-link" v-if="deadline">
                    <div class="calendar-link__icon calendar-link__icon--yahoo"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Yahoo Calendar</div>
                    </div>
                    <button class="calendar-link__btn" @click="copyToClipboard(generateCalendarLinks().yahoo)">

                      Copy
                    </button>
                  </div>

                  <div class="calendar-link  ">
                    <div class="calendar-link__icon calendar-link__icon--download"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Download ICS File</div>
                      <div class="calendar-link__description">Compatible with all calendar apps</div>
                    </div>
                    <button class="calendar-link__btn" @click="downloadICSFile">

                      Download
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>

      <div v-else>
        <button class="modal__button modal__button--submit button button--default" @click="addLead()">
          <span>{{ $t(`addLeadModal.${'saveBtn'}`) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onUnmounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import DropFile from "@/components/DropFile";
import Loading from "@/partials/Loading";
import MultiSelectDropdown from "@/partials/MultiSelectDropdown";
import statics from "@/statics";

defineOptions({
  name: "AddLeadModal"
});

// Setup contexts
const store = useStore();
const route = useRoute();
const router = useRouter();
const { proxy } = getCurrentInstance();

// Reactive State (replaces data())
const formLoading = ref(true);
const isRequesting = ref(false);

const agentId = ref("");
const categoryIds = ref([]);
const referalId = ref("");
const referalNote = ref("");
const methodId = ref("");
const responseId = ref("");
const statusId = ref("");
const deadline = ref("");
const comment = ref("");
const files = ref([]);

const agentHasError = ref(false);
const referalHasError = ref(false);
const statusHasError = ref(false);

const durationMinutes = ref(null);
const durationMinutesCustom = ref(null);
const hours = ref("");
const minutes = ref("");
const date = ref("");
const time = ref("00:00");
const callId = ref(null);

const dateHasError = ref(false);
const timeHasError = ref(false);
const durationHasError = ref(false);
const deadlineHasError = ref(false);

const teamId = ref(null);

// Computed properties (replaces computed)
const customerDetails = computed(() => store.getters.customerDetails);
const leadCustomerForms = computed(() => store.getters.leadCustomerForms);
const loggedUser = computed(() => store.getters.loggedUser);
const leadToEdit = computed(() => store.getters.leadToEdit);
const leadsPerPage = computed(() => store.getters.leadsPerPage);

const isEditMode = computed(() => !!leadToEdit.value);

const latestLead = computed(() => {
  if (customerDetails.value?.latest_lead) {
    return customerDetails.value.latest_lead;
  }
  if (leadsPerPage.value?.data && leadsPerPage.value.data.length > 0) {
    return leadsPerPage.value.data[0];
  }
  return null;
});

const agents = computed(() => leadCustomerForms.value.agents || []);
const categories = computed(() => leadCustomerForms.value.branchCategories || []);
const referals = computed(() => leadCustomerForms.value.referrals || []);
const methods = computed(() => leadCustomerForms.value.contactMethods || []);
const responses = computed(() => leadCustomerForms.value.response || []);
const statuses = computed(() => leadCustomerForms.value.statuses);

// Methods
const validateMinutes = () => {
  if (durationMinutes.value) {
    durationMinutes.value = null;
  }
  if (minutes.value > 59) {
    minutes.value = 59;
  } else if (minutes.value < 0 || isNaN(minutes.value)) {
    minutes.value = "";
  }
};

const validateHours = () => {
  if (durationMinutes.value) {
    durationMinutes.value = null;
  }
  if (hours.value < 0 || isNaN(hours.value)) {
    hours.value = "";
  }
};

const updateCallDuration = () => {
  let timeString = 0;
  if (Number(hours.value) && Number(hours.value) > 0) {
    timeString = Number(hours.value) * 60;
  }
  if (minutes.value && Number(minutes.value) > 0) {
    timeString += Number(minutes.value);
  }
  durationMinutesCustom.value = timeString;
};

const selectCallDuration = (callDuration) => {
  hours.value = "";
  minutes.value = "";
  durationMinutesCustom.value = null;
  durationMinutes.value = callDuration;
};

const closeModal = () => {
  store.commit("setShowAddLeadModal", false);
  store.commit("setLeadToEdit", null);
  files.value = [];

  if (route.name === 'Leads') {
    store.commit("setCustomerDetails", null);
    store.commit("setCustomerDetailsId", null);
  }
};

const populateFormForEdit = () => {
  if (!leadToEdit.value) return;

  const lead = leadToEdit.value;

  if (lead.customer && !customerDetails.value) {
    store.commit("setCustomerDetails", lead.customer);
    store.commit("setCustomerDetailsId", lead.customer.id);
  }

  agentId.value = lead.agent?.id || "";
  categoryIds.value = lead.branch_categories?.map(cat => cat.id) || [];
  referalId.value = lead.referral?.id || "";
  referalNote.value = lead.referral_note || "";
  methodId.value = lead.contact_method || "";
  responseId.value = lead.response || "";
  statusId.value = lead.status?.id || "";
  deadline.value = lead.deadline || "";
  comment.value = lead.comment || "";

  if (lead.calls && lead.calls.length > 0) {
    callId.value = lead.calls[0].id;
    date.value = lead.calls[0].date;
    const callTime = lead.calls[0].time;
    if (callTime) {
      time.value = callTime.substring(0, 5);
    }

    const duration = lead.calls[0].duration_minutes;
    if (duration === 15 || duration === 30 || duration === 45) {
      durationMinutes.value = duration;
    } else if (duration) {
      hours.value = Math.floor(duration / 60);
      minutes.value = duration % 60;
      durationMinutesCustom.value = duration;
    }
  }

  if (lead.customer?.team?.id) {
    teamId.value = Number(lead.customer.team.id);
  }
};

const populateFromLatestLead = () => {
  if (!latestLead.value) return;

  if (latestLead.value.branch_categories && latestLead.value.branch_categories.length > 0) {
    categoryIds.value = latestLead.value.branch_categories.map(cat => cat.id);
  }

  if (latestLead.value.referral?.id) {
    referalId.value = latestLead.value.referral.id;
  }

  if (latestLead.value.agent?.id) {
    agentId.value = latestLead.value.agent.id;
  }

  if (latestLead.value.status?.id) {
    statusId.value = latestLead.value.status.id;
  }

  if (latestLead.value.referral_note) {
    referalNote.value = latestLead.value.referral_note;
  }
};

const setCurrentDateTime = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  date.value = `${year}-${month}-${day}`;

  const currentHours = String(now.getHours()).padStart(2, '0');
  const currentMinutes = String(now.getMinutes()).padStart(2, '0');
  time.value = `${currentHours}:${currentMinutes}`;
};

const validateFields = (callback) => {
  agentHasError.value = !agentId.value;
  referalHasError.value = !referalId.value;
  statusHasError.value = !statusId.value;

  if (methodId.value === 'termin') {
    deadlineHasError.value = !deadline.value;
    dateHasError.value = false;
    timeHasError.value = false;
    durationHasError.value = false;
  } else if (responseId.value === 'yes' && methodId.value === 'phone') {
    dateHasError.value = !date.value;
    timeHasError.value = !time.value || time.value === "00:00";
    const totalDuration = durationMinutes.value || durationMinutesCustom.value;
    durationHasError.value = !totalDuration || totalDuration === 0;
    deadlineHasError.value = false;
  } else {
    dateHasError.value = false;
    timeHasError.value = false;
    durationHasError.value = false;
    deadlineHasError.value = false;
  }

  const isValid = !agentHasError.value && !referalHasError.value && !statusHasError.value &&
    !dateHasError.value && !timeHasError.value && !durationHasError.value && !deadlineHasError.value;

  callback(isValid);
};

const formatTimeBeforeSend = (timeVal) => {
  if (typeof timeVal === 'object' && timeVal !== null) {
    const formatHours = timeVal.HH || timeVal.hh || '00';
    const formatMinutes = timeVal.mm || '00';
    return `${formatHours}:${formatMinutes}`;
  }

  if (typeof timeVal === 'string') {
    let [formatHours, formatMinutes] = timeVal.split(':');
    return `${formatHours}:${formatMinutes}`;
  }

  return '00:00';
};

const setDefaultAgentIfNeeded = () => {
  if (agentId.value) return;

  if ((!agents.value || agents.value.length === 0) && loggedUser.value && loggedUser.value.id) {
    agentId.value = loggedUser.value.id;
  }
};

const addLead = async () => {
  isRequesting.value = true;

  if (!customerDetails.value || !customerDetails.value.id) {
    store.commit("setToast", {
      display: true,
      type: "error",
      message: proxy.$t('addLeadModal.noCustomerSelectedError'),
    });
    isRequesting.value = false;
    return;
  }

  validateFields(async (isValid) => {
    if (isValid) {
      try {
        const leadData = {
          team_id: teamId.value,
          agent_id: agentId.value,
          customer_id: customerDetails.value.id,
          branch_category_ids: categoryIds.value,
          referral_id: referalId.value,
          status_id: statusId.value,
          contact_method: methodId.value,
          response: responseId.value,
          deadline: deadline.value,
          comment: comment.value,
          referral_note: referalNote.value,
        };

        if (responseId.value === 'yes' && methodId.value === 'phone') {
          leadData.call_date = date.value;
          leadData.call_time = formatTimeBeforeSend(time.value);
          leadData.call_duration_minutes = durationMinutes.value || durationMinutesCustom.value || 0;

          if (isEditMode.value && callId.value) {
            leadData.call_id = callId.value;
          }
        }

        const statusNum = Number(statusId.value);
        const willRedirect = statusNum === 4 && customerDetails.value && customerDetails.value.id;
        const currentCustomerId = customerDetails.value.id;

        if (isEditMode.value) {
          await store.dispatch('updateLead', {
            leadId: leadToEdit.value.id,
            leadData
          });
        } else {
          const mappedFiles = files.value.map((file) => file.file);
          await store.dispatch('createLead', { leadData, files: mappedFiles });

          if (route.name === 'Leads' && !willRedirect) {
            await store.dispatch('fetchLeadCustomers');
          }
        }

        closeModal();

        if (willRedirect) {
          await store.dispatch('getGlobalCustomer', currentCustomerId);
          await router.replace({
            path: `/account-details/customer/${currentCustomerId}`,
            query: { tab: 5 }
          });
          store.commit('setShowAddCustomerServicesModal', true);
        }
      } catch (error) {
        // Handled by store
      } finally {
        isRequesting.value = false;
      }
    } else {
      store.commit("setToast", {
        display: true,
        type: "error",
        message: proxy.$t('addLeadModal.validationError'),
      });
      isRequesting.value = false;
    }
  });
};

const copyToClipboard = async (url) => {
  try {
    await navigator.clipboard.writeText(url);
    window.open(url, '_blank');
    store.commit("setToast", {
      display: true,
      type: "success",
      message: proxy.$t('calendar.copySuccess'),
    });
  } catch (error) {
    store.commit("setToast", {
      display: true,
      type: "error",
      message: proxy.$t('calendar.copyError'),
    });
  }
};

const generateCalendarLinks = () => {
  if (!deadline.value) {
    return null;
  }

  const [year, month, day] = deadline.value.split('-');
  const startDate = new Date(year, month - 1, day, 12, 0);
  const eventDuration = 60;

  if (!startDate || isNaN(startDate.getTime())) {
    return null;
  }

  const endDate = new Date(startDate);
  endDate.setMinutes(endDate.getMinutes() + eventDuration);

  const customerName = customerDetails.value?.first_name
    ? `${customerDetails.value.first_name} ${customerDetails.value.last_name}`
    : customerDetails.value?.company_name || 'Customer';

  const eventTitle = encodeURIComponent(`Follow-up - ${customerName}`);

  let descriptionParts = [];

  descriptionParts.push(`Customer: ${customerName}`);

  if (categoryIds.value && categoryIds.value.length > 0) {
    const selectedCategories = categories.value
      .filter(cat => categoryIds.value.includes(cat.id))
      .map(cat => cat.name)
      .join(', ');
    if (selectedCategories) {
      descriptionParts.push(`Categories: ${selectedCategories}`);
    }
  }

  if (statusId.value) {
    const selectedStatus = statuses.value?.find(s => s.id === statusId.value);
    if (selectedStatus) {
      descriptionParts.push(`Status: ${selectedStatus.name}`);
    }
  }

  if (agentId.value) {
    const selectedAgent = agents.value?.find(a => a.id === agentId.value) || loggedUser.value;
    if (selectedAgent) {
      descriptionParts.push(`Agent: ${selectedAgent.first_name} ${selectedAgent.last_name}`);
    }
  }

  if (methodId.value) {
    const selectedMethod = methods.value?.find(m => m.value === methodId.value);
    if (selectedMethod) {
      descriptionParts.push(`Method: ${selectedMethod.label}`);
    }
  }

  if (responseId.value) {
    const selectedResponse = responses.value?.find(r => r.value === responseId.value);
    if (selectedResponse) {
      descriptionParts.push(`Response: ${selectedResponse.label}`);
    }
  }

  if (referalId.value) {
    const selectedReferal = referals.value?.find(r => r.id === referalId.value);
    if (selectedReferal) {
      descriptionParts.push(`Referral: ${selectedReferal.name}`);
    }
  }

  if (referalNote.value) {
    descriptionParts.push(`Referral Note: ${referalNote.value}`);
  }

  if (comment.value) {
    descriptionParts.push(`Notes: ${comment.value}`);
  }

  const eventDescription = encodeURIComponent(descriptionParts.join('\n'));

  const formatDateTime = (d) => {
    return d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const startDateTime = formatDateTime(startDate);
  const endDateTime = formatDateTime(endDate);

  return {
    google: `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${startDateTime}/${endDateTime}&details=${eventDescription}`,
    outlook: `https://outlook.live.com/owa/?path=/calendar/action/compose&rru=addevent&subject=${eventTitle}&startdt=${startDateTime}&enddt=${endDateTime}&body=${eventDescription}`,
    office365: `https://outlook.office.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${eventTitle}&startdt=${startDateTime}&enddt=${endDateTime}&body=${eventDescription}`,
    yahoo: `https://calendar.yahoo.com/?v=60&view=d&type=20&title=${eventTitle}&st=${startDateTime}&et=${endDateTime}&desc=${eventDescription}`
  };
};

const downloadICSFile = () => {
  if (!deadline.value) {
    store.commit("setToast", {
      display: true,
      type: "warning",
      message: proxy.$t('calendar.noEventData'),
    });
    return;
  }

  const [year, month, day] = deadline.value.split('-');
  const startDate = new Date(year, month - 1, day, 12, 0);
  const eventDuration = 60;
  const dateString = deadline.value;

  if (!startDate || isNaN(startDate.getTime())) {
    store.commit("setToast", {
      display: true,
      type: "warning",
      message: proxy.$t('calendar.noEventData'),
    });
    return;
  }

  const endDate = new Date(startDate);
  endDate.setMinutes(endDate.getMinutes() + eventDuration);

  const formatICSDate = (d) => {
    return d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const customerName = customerDetails.value?.first_name
    ? `${customerDetails.value.first_name} ${customerDetails.value.last_name}`
    : customerDetails.value?.company_name || 'Customer';

  let descriptionParts = [];

  descriptionParts.push(`Customer: ${customerName}`);

  if (categoryIds.value && categoryIds.value.length > 0) {
    const selectedCategories = categories.value
      .filter(cat => categoryIds.value.includes(cat.id))
      .map(cat => cat.name)
      .join(', ');
    if (selectedCategories) {
      descriptionParts.push(`Categories: ${selectedCategories}`);
    }
  }

  if (statusId.value) {
    const selectedStatus = statuses.value?.find(s => s.id === statusId.value);
    if (selectedStatus) {
      descriptionParts.push(`Status: ${selectedStatus.name}`);
    }
  }

  if (agentId.value) {
    const selectedAgent = agents.value?.find(a => a.id === agentId.value) || loggedUser.value;
    if (selectedAgent) {
      descriptionParts.push(`Agent: ${selectedAgent.first_name} ${selectedAgent.last_name}`);
    }
  }

  if (methodId.value) {
    const selectedMethod = methods.value?.find(m => m.value === methodId.value);
    if (selectedMethod) {
      descriptionParts.push(`Method: ${selectedMethod.label}`);
    }
  }

  if (responseId.value) {
    const selectedResponse = responses.value?.find(r => r.value === responseId.value);
    if (selectedResponse) {
      descriptionParts.push(`Response: ${selectedResponse.label}`);
    }
  }

  if (referalId.value) {
    const selectedReferal = referals.value?.find(r => r.id === referalId.value);
    if (selectedReferal) {
      descriptionParts.push(`Referral: ${selectedReferal.name}`);
    }
  }

  if (referalNote.value) {
    descriptionParts.push(`Referral Note: ${referalNote.value}`);
  }

  if (comment.value) {
    descriptionParts.push(`Notes: ${comment.value}`);
  }

  const description = descriptionParts.join('\\n').replace(/\n/g, '\\n');

  const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Lead Management//Follow-up//EN
BEGIN:VEVENT
UID:${Date.now()}@leadsystem.com
DTSTAMP:${formatICSDate(new Date())}
DTSTART:${formatICSDate(startDate)}
DTEND:${formatICSDate(endDate)}
SUMMARY:Follow-up - ${customerName}
DESCRIPTION:${description}
STATUS:CONFIRMED
END:VEVENT
END:VCALENDAR`;

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `follow-up-${dateString}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);

  store.commit("setToast", {
    display: true,
    type: "success",
    message: proxy.$t('calendar.downloadSuccess') ,
  });
};

// Watchers
watch(minutes, updateCallDuration);
watch(hours, updateCallDuration);

watch(time, (value) => {
  timeHasError.value = !(value && value !== "00:00");
});

watch(date, (value) => {
  dateHasError.value = !value;
});

watch(deadline, (value) => {
  if (value) {
    deadlineHasError.value = false;
  } else if (methodId.value === 'termin') {
    deadlineHasError.value = true;
  }
});

watch(durationMinutesCustom, (value) => {
  durationHasError.value = !value;
});

watch(durationMinutes, (value) => {
  durationHasError.value = !value;
});

watch(agentId, (value) => {
  agentHasError.value = !value;
});

watch(referalId, (value) => {
  referalHasError.value = !value;
});

watch(statusId, (value) => {
  statusHasError.value = !value;
});

watch(responseId, (newValue) => {
  if (newValue === 'yes' && !isEditMode.value) {
    if (!date.value || !time.value || time.value === '00:00') {
      setCurrentDateTime();
    }
  }
});

watch(methodId, (value) => {
  if (value === 'termin') {
    deadlineHasError.value = !deadline.value;
  } else {
    deadlineHasError.value = false;
  }
});

watch(customerDetails, async (newVal) => {
  if (!newVal || !newVal.team) return;
  if (leadCustomerForms.value && Object.keys(leadCustomerForms.value).length > 0) return;
  formLoading.value = true;
  teamId.value = Number(newVal.team.id);
  await store.dispatch("getLeadCustomerForms", teamId.value);

  setDefaultAgentIfNeeded();

  if (!isEditMode.value && latestLead.value) {
    populateFromLatestLead();
  }

  formLoading.value = false;
});

watch(loggedUser, (newVal) => {
  if (!newVal) return;
  setDefaultAgentIfNeeded();
});

watch(leadToEdit, {
  async handler(newVal) {
    if (newVal) {
      populateFormForEdit();

      if (customerDetails.value?.team && (!leadCustomerForms.value || Object.keys(leadCustomerForms.value).length === 0)) {
        formLoading.value = true;
        teamId.value = Number(customerDetails.value.team.id);
        await store.dispatch("getLeadCustomerForms", teamId.value);
        formLoading.value = false;
      }
    }
  },
  immediate: true,
});

// Created Hooks logic
const initializeComponent = async () => {
  formLoading.value = true;

  if (!(proxy.$checkRolePermission('customer_create') && proxy.$checkRolePermission('customer_edit'))) {
    closeModal();
  } else {
    populateFormForEdit();

    if (customerDetails.value && customerDetails.value.team) {
      teamId.value = Number(customerDetails.value.team.id);
      await store.dispatch("getLeadCustomerForms", teamId.value);
    }

    setDefaultAgentIfNeeded();

    if (!isEditMode.value && latestLead.value) {
      populateFromLatestLead();
    }
  }

  formLoading.value = false;
};
initializeComponent();

// Unmounted cleanup replacement
onUnmounted(() => {
  closeModal();
});
</script>
<style scoped lang="scss">
@use "../assets/scss/termination-potential-policy";

.dobule-form-fields {
  display: flex;
  justify-content: space-between;
}

.big-form-field {
  width: 100% !important;
}

.small-form-field {
  width: 49% !important;
}

.termination__row {
  border: 0;
}

// .termination__textarea__row {
//   margin-top: -40px !important;
// }

.custom-duration-wrapper {

  background-color: var(--bg-3);

  color: var(--text-3);
  padding: 0 10px;
  font-size: var(--x-small);
  border-radius: var(--radius-1);
  font-family: var(--muli-text-semi-bold);
  border: 1px solid transparent;


  display: flex;
  align-items: center;
  padding: 0;

}

.custom-duration {
  background-color: transparent;
  //  border: 1px solid ;
  height: 40px;
  color: var(--text-3);

  font-size: var(--x-small);
  text-align: center;
  font-family: var(--muli-text-semi-bold);
}


.time-picker {
  width: 100%;
  padding: .3em .5em;
  font-size: 1em;
  height: 100%;
  background-color: transparent;
  border: none;
  text-align: center;
  color: var(--text-2);
  font-family: var(--muli-text-semi-bold);
}

.form__field__call__duration {
  margin-top: -8px;
}

.call__duration__label {
  margin-bottom: -6px;
}

[data-theme="dark"] .call__duration__label {
  p {
    color: white;
  }
}


.call__duration__label p {
  color: #7F8FA480;
  font-size: 14px;
}


.call__duration__types {
  display: flex;
  gap: 12px;
}


.call__duration__value {
  color: #B9C2CD;
  font-size: 16px;
  cursor: pointer;
}


.call__duration__value--active {
  color: #22DB8E;
}



.custom-time-input {
  position: relative;
  width: 48%;
}

.custom-input {
  appearance: none;
  color: var(--text-2);
  background-color: var(--bg-3);
  border-radius: 10px;
  padding: 0 10px;
  height: 40px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
}

.custom-input::placeholder {
  font-family: var(--muli-text-semi-bold);
  color: var(--text-8);
}


.date-picker {
  width: 48%;
  position: relative;
  z-index: 1;
}

.date-time-wrapper {
  display: flex;
  justify-content: space-between;
}


.form__notes__textarea {
  width: 70%;
}

// Calendar Links Styling
.url-links {
  margin-top: 20px;
  width: 100%;
}

.url-links__title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-9);
  margin: 0 0 8px 0;
  font-family: var(--muli-text-bold);
}

.url-links__subtitle {
  font-size: 14px;
  color: var(--text-9);
  margin: 0 0 20px 0;
  font-family: var(--muli-text-regular);
}

.calendar-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: var(--bg-3);
  border-radius: 10px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  width: 32%;

  &:not(:nth-of-type(3n)) {
    margin-right: 2%;
  }

  &:last-child {
    width: 66%;
    margin: 0;
  }

  &:hover {
    border-color: var(--border-2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &--download {
    margin-bottom: 16px;
  }
}

.calendar-link__icon {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;

  &--google {
    &::before {
      content: '📅';
    }
  }

  &--outlook {
    &::before {
      content: '📧';
    }
  }

  &--office365 {
    &::before {
      content: '📊';
    }
  }

  &--yahoo {
    &::before {
      content: '📆';
    }
  }

  &--download {
    &::before {
      content: '📥';
    }
  }
}

.calendar-link__content {
  flex: 1;
  min-width: 0;
}

.calendar-link__name {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-9);
  margin-bottom: 4px;
  font-family: var(--muli-text-semi-bold);
}

.calendar-link__url {
  font-size: 13px;
  color: var(--text-9);
  font-family: var(--muli-text-semi-bold);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-link__description {
  font-size: 13px;
  color: var(--text-9);
  font-family: var(--muli-text-regular);
}

.calendar-link__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: transparent;
  border-radius: 6px;
  color: var(--text-9);
  font-size: 14px;
  font-family: var(--muli-text-semi-bold);
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  background-color: var(--bg-1);

  &:hover {
    background-color: var(--bg-3);
    border-color: var(--border-2);
  }

  &:active {
    transform: scale(0.98);
  }
} 
</style>
